import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  version: "1.1",
  id: "__Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "1224.3 0 45 45",
  "enable-background": "new 1224.3 0 45 45",
  "xml:space": "preserve"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1229.5,22.1c0-0.2,0-0.4-0.1-0.6c0-0.1,0.1-0.3,0.2-0.3c0.1,0,0.1,0,0.2,0c0.1,0,0.2-0.1,0.2-0.2\r\n\tc0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.3,0,0.4,0c0.2,0,0.3,0.1,0.3,0.2c0.1,0.5,0.1,1.1,0.2,1.6c0,0.2-0.1,0.3-0.3,0.3c-0.1,0-0.3,0-0.4,0\r\n\tc-0.1,0-0.3-0.1-0.3-0.2c0-0.1-0.1-0.3-0.3-0.2c-0.1,0-0.1,0-0.2,0C1229.6,22.3,1229.5,22.2,1229.5,22.1z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1263.8,10.7c-0.3,0.2-0.6,0.3-0.9,0.5c-0.1,0-0.1,0.1-0.1,0.2c-0.1,0.6-0.2,0.8-0.3,1\r\n\tc-0.2,0.3-0.5,0.5-2.4,1.2c-1.9,0.7-5.5,2-7.8,2.8c-2.3,0.8-3.3,1-4.5,1.1c-1,0.1-2.2,0.1-6.3-0.9c-0.2-0.1-0.4,0.2-0.3,0.4\r\n\tc0.4,0.9,0.9,1.8,1.3,2.7c0.2,0.5,0.7,0.7,1.2,0.7c1-0.1,2.2,0,3.6,0.1c0.2,0,0.4,0,0.6-0.1c14.7-5.8,15.1-6.1,15.5-6.4\r\n\tc0.4-0.4,0.6-0.8,0.7-1.3c0.1-0.3,0.2-0.7,0.2-1.7C1264.2,10.8,1264,10.7,1263.8,10.7z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1241.9,35.6c0.4,0,0.7,0,1.1,0c0.7,0,1.2-0.5,1.2-1.2c0-2.7,0-5.3,0-8c0-0.2,0-0.3-0.1-0.5\r\n\tc-1.3-2.7-2.5-5.5-3.8-8.2c-0.2-0.5-0.8-0.8-1.4-0.7c-2.7,0.7-5.1,1.7-7.4,3c-0.1,0.1-0.1,0.2-0.1,0.3c0.1,0.8,0.2,1.6,0.3,2.4\r\n\tc0,0.2,0.2,0.3,0.3,0.2c2-0.6,4.1-0.2,5.7,1c1.6,1.2,2.7,3.1,2.7,5.1c0.1,1.8,0.1,3.6,0.2,5.3C1240.7,35,1241.3,35.6,1241.9,35.6z"
    }, null, -1)
  ])))
}
export default { render: render }